module.exports = __webpack_public_path__ + "static/other/diseased_trees_game_1.705778f6.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/diseaseTreesGame/diseased_trees_game_1.json
// module id = 2360
// module chunks = 0